import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.concat.js";
import i18n from 'i18next';
export function getDistributedInfo(_ref) {
  var id = _ref.id,
    originatingId = _ref.originatingId,
    sourceDomain = _ref.sourceDomain,
    _ref$contentType = _ref.contentType,
    contentType = _ref$contentType === void 0 ? 'playlist' : _ref$contentType;
  var hubName = sourceDomain !== null && sourceDomain !== void 0 && sourceDomain.origin ? sourceDomain.name || sourceDomain.origin : i18n.t('immutability_note_parenthub_another_hub');
  var sourceId = originatingId || id;
  var sourceUrl = sourceDomain !== null && sourceDomain !== void 0 && sourceDomain.origin ? contentType === 'playlist' ? "".concat(sourceDomain.origin, "/admin/playlists/").concat(sourceId) : "".concat(sourceDomain.origin, "/admin/assets") : '';
  return {
    hubName: hubName,
    sourceUrl: sourceUrl
  };
}